import $ from 'jquery';
// import { debounce } from 'lodash';
// /**
//  * ==================================================
//  * Sets the wrapper people slider for accessibility
//  * ==================================================
//  *
//  * This file dynamically sets the tabIndex and focus by observing for mutations
//  *
//  * @Author Amal Ajith PM
//  */
// $(document).ready(function() {
//   /**
//      *
//      * @type {NodeListOf<HTMLDivElement>}
//      */
//   const slideNodes = document.querySelectorAll('.wrapper-people-slider .slide');
//   const slideNavButtons = document.querySelectorAll('.wrapper-people-slider .slider-nav button');
//   /**
//      * The mutation configuration
//      * @type {{attributesFilter: string[], attributes: boolean}}
//      */
//   const classMutationConfig = { attributes: true, attributeFilter: ['class'] };
//   /**
//      *
//      * @param {HTMLDivElement} slide
//      * @param {Boolean} makeTabbable
//      */
//   const toggleStateOfTabbableItemsInSlide = (slide, makeTabbable) => {
//     /**
//          *
//          * @type {NodeListOf<HTMLAnchorElement>}
//          */
//     const slideLinks = slide.querySelectorAll('a');
//     slideLinks.forEach((linkItem) => {
//       linkItem.tabIndex = makeTabbable ? '0' : '-1';
//     });
//   };
//   /**
//      * Callback function when a mutation happens.
//      * We are looking for class mutation of active.
//      * @param mutationsList
//      * @param observer
//      * @type {MutationCallback}
//      */
//   const onSlideActiveClassMutation = (mutationsList, observer) => {
//     for(const mutation of mutationsList) {
//       if (mutation.type === 'attributes') {
//         const observingClassNames = ['active'];
//         if(mutation.target.classList.contains(observingClassNames)){
//           toggleStateOfTabbableItemsInSlide(mutation.target, true);
//         } else {
//           toggleStateOfTabbableItemsInSlide(mutation.target, false);
//         }
//       }
//     }
//   };
//   /**
//      * Set up the observer to watch for active class in slide
//      */
//   const observeForActiveClassMutations = () => {
//     if(slideNodes && slideNodes.length > 0) {
//       slideNodes.forEach((slideItem) => {
//         const observer = new MutationObserver(onSlideActiveClassMutation);
//         //Observe for class mutations
//         observer.observe(slideItem, classMutationConfig);
//       });
//     }
//   };
//   observeForActiveClassMutations();
//   /**
//    * Run on page load,
//    */
//   const prepareSlidesForAccessibility = () => {
//     if(slideNodes && slideNodes.length > 0) {
//       slideNodes.forEach((slideItem) => {
//         if(slideItem.classList.contains(['active'])){
//           toggleStateOfTabbableItemsInSlide(slideItem, true);
//         } else {
//           toggleStateOfTabbableItemsInSlide(slideItem, false);
//         }
//       });
//     }
//   };
//   prepareSlidesForAccessibility();
//   /**
//      * Callback function when a mutation happens.
//      * We are looking for class mutation of active.
//      * @param mutationsList
//      * @param observer
//      * @type {MutationCallback}
//      */
//   const onSlideButtonInActiveClassMutation = (mutationsList, observer) => {
//     for(const mutation of mutationsList) {
//       if (mutation.type === 'attributes') {
//         const observingClassNames = ['inactive'];
//         if(mutation.target.classList.contains(observingClassNames)){
//           mutation.target.tabIndex = '-1';
//         } else {
//           mutation.target.tabIndex = '0';
//         }
//       }
//     }
//   };
//   /**
//      * Set up the observer to watch for active class in slide
//      */
//   const observeForSlideButtonInActiveClassMutations = () => {
//     if(slideNavButtons && slideNavButtons.length > 0) {
//       slideNavButtons.forEach((buttonItem) => {
//         const observer = new MutationObserver(onSlideButtonInActiveClassMutation);
//         //Observe for class mutations
//         observer.observe(buttonItem, classMutationConfig);
//       });
//     }
//   };
//   observeForSlideButtonInActiveClassMutations();
// });
// // End of accessibility
// // -----------------------------------------------------------------------------------------------------------
// // --- Slider ---
// // Resize slider
// (function ($) {
//   function sliderResizer (mySlider) {
//     // How many slides are in a row?
//     let childrenL = mySlider.find('.slider-list').children().length,
//       slideCols = Math.floor(mySlider.outerWidth() / mySlider.find('.slide').outerWidth());
//   }
//   // $('.feature-slider-div').each(function(){
//   //   let childrenL = $(this).find('.slider-list').children().length;
//   //   $(this).find('.Feature-slider').addClass('slider-nav'+childrenL);
//   // });
//   // Initiate slider
//   $('.wrapper-people-slider .slider').each(function(){
//     // Create a paginator
//     if ($(this).find('.people-slider-paginator').length <= 0) {
//       if ($(this).parents('.wrapper-people-slider').length) {
//         if ($(this).find('.people-slider-paginator').length > 1) {
//           $(this).append('<ul class="people-slider-paginator hidden"></ul>');
//         }
//       } else {
//         $(this).append('<ul class="people-slider-paginator hidden"></ul>');
//       }
//     }
//     let childrenL = $(this).find('.slider-list .slide').length,
//       myPaginator = $(this).find('.people-slider-paginator');
//     /*
//     * The following check was applied to remove the slider navigation
//     * if only one element is in the slider. Currently, it is applied
//     * only for "People Slider" block.
//     */
//     if ($(this).parents('.wrapper-people-slider').length) {
//       if (childrenL > 1) {
//         for(var i = 1; i <= childrenL; ++i){
//           $('<li/>').attr('data-slider', i).appendTo(myPaginator);
//         }
//       } else {
//         $(this).find('.slider-nav').remove();
//       }
//     } else {
//       for(var i = 1; i <= childrenL; ++i){
//         $('<li/>').attr('data-slider', i).appendTo(myPaginator);
//       }
//     }
//     $(this).find('.people-slider-paginator li:first-child').addClass('active');
//     sliderResizer($(this));
//   });
//   // Click a paginator point
//   $('.people-slider-paginator li').on('click',function(){
//     let myParent = $(this).parents('.slider'),
//       pos = $(this).attr('data-slider');
//     // Boxed slider
//     if (myParent.hasClass('slider-boxed')){
//       // Count left margin
//       let newleft = - myParent.find('.slide:nth-child(' + pos + ')').position().left
//                 - parseFloat(myParent.find('.slide:nth-child(' + pos + ')').css('margin-left'));
//       // Sliders overflowing from the container are still justified to it:
//       let containerReducer = $('.container').offset().left + parseFloat($('.container').css('padding-left'));
//       if (myParent.parents('.section').hasClass('wrapper-people-slider') && $(window).width() < 768){
//         newleft += containerReducer;
//       }
//       // Animate list
//       myParent.find('.slider-list').animate({left: newleft}, 500);
//       // Deactivate previous slide
//       myParent.find('.people-slider-paginator li').removeClass('active');
//       myParent.find('.slide').removeClass('active');
//       // Activate this slide and paginator point
//       myParent.find('.people-slider-paginator li[data-slider='+pos+']').addClass('active');
//       myParent.find('.slide:nth-child(' + pos + ')').addClass('active');
//     // Slide fader
//     } else if (myParent.hasClass('slider-fader')) {
//       let newSlide = myParent.find('.slide:nth-child(' + pos + ')');
//       // Activate proper paginator point
//       myParent.find('.people-slider-paginator li').removeClass('active');
//       myParent.find('.people-slider-paginator li[data-slider=' + pos + ']').addClass('active');
//       // Set new height for list
//       setTimeout(function(){
//         let newH = newSlide.outerHeight();
//         myParent.find('.slider-list').animate(
//           { height: newH },
//           300
//         );
//       }, 100);
//       // Activate current slide
//       myParent.find('.slide.active').addClass('active-fading-out');
//       setTimeout(function(){
//         myParent.find('.slide.active').removeClass('active active-fading-out');
//         newSlide.addClass('active-fading-in');
//         setTimeout(function(){
//           newSlide.removeClass('active-fading-in').addClass('active');
//         }, 150);
//       }, 100);
//     }
//     // Deactivate loop
//     if ($(this).prev().first().length <= 0) {
//       myParent.find('.slider-prev').addClass('inactive');
//     } else {
//       myParent.find('.slider-prev').removeClass('inactive');
//     }
//     if ($(this).next().first().length <= 0) {
//       myParent.find('.slider-next').addClass('inactive');
//     } else {
//       myParent.find('.slider-next').removeClass('inactive');
//     }
//   });
//   // Click a prev/next button
//   $('.wrapper-people-slider .slider-prev').on('click', function(){
//     let myParent = $(this).parents('.slider'),
//       currentActive = myParent.find('.people-slider-paginator li.active').first();
//     if(currentActive.prev().length > 0){
//       currentActive.prev().first().click();
//     } else {
//       myParent.find('.people-slider-paginator li:last-child').click();
//     }
//   });
//   $('.wrapper-people-slider .slider-next').on('click',function(){
//     let myParent = $(this).parents('.slider'),
//       currentActive = myParent.find('.people-slider-paginator li.active').last();
//     if(currentActive.next().length > 0){
//       currentActive.next().first().click();
//     } else {
//       myParent.find('.people-slider-paginator li:first-child').click();
//     }
//   });
//   // Swipe the slider
//   $('.slider').swipe({
//     allowPageScroll: 'vertical',
//     preventDefaultEvents: false,
//     swipe: function(event, direction, distance, duration, fingerCount, fingerData){
//       if($(window).width() <= 767){
//         let myParent = $(event.target).parents('.slider');
//         myParent.find('.people-slider-paginator').children().each(function(){
//           if($(this).hasClass('active')){
//             if(direction == 'left' && $(this).next().length > 0){
//               $(this).next().first().click();
//               return false;
//             } else if(direction == 'left' && $(this).next().length === 0){
//               myParent.find('.people-slider-paginator li').first().click();
//               return false;
//             } else if(direction == 'right' && $(this).prev().length > 0){
//               $(this).prev().first().click();
//               return false;
//             } else if(direction == 'right' && $(this).prev().length === 0){
//               myParent.find('.people-slider-paginator li').last().click();
//               return false;
//             }
//           }
//         });
//       }
//     },
//     excludedElements: 'label, button, input, select, textarea, .noSwipe'
//   });
//   // Activate sliders on ready and re-activate sliders after resizing
//   function sliderActivator (mySlider) {
//     mySlider.find('.people-slider-paginator li.active').click();
//   }
//   $(window).resize(debounce(function(){
//     $('.wrapper-people-slider .slider:not(.slider-fader)').each(function(){
//       sliderResizer($(this));
//       sliderActivator($(this));
//     });
//     // Resize slider-fader
//     $('.wrapper-people-slider .slider.slider-fader').each(function(){
//       let newH = $(this).find('.slide.active').outerHeight();
//       $(this).find('.slider-list').animate(
//         { height: newH },
//         100
//       );
//     });
//   }, 100 ));
//   $('.wrapper-people-slider .slider').each(function(){
//     sliderActivator($(this));
//   });
// })(jQuery);
// // End of Slider
// Bind event handler for the previous arrow button
$('.people-slider .slick-prev').click(function () {
    $('.slider-list').slick('slickPrev');
});
// Bind event handler for the next arrow button
$('.people-slider .slick-next').click(function () {
    $('.slider-list').slick('slickNext');
});
